import { render, staticRenderFns } from "./CsvTkc.vue?vue&type=template&id=2f17b279&scoped=true&lang=pug&"
import script from "./scripts/CsvTkc.js?vue&type=script&lang=js&"
export * from "./scripts/CsvTkc.js?vue&type=script&lang=js&"
import style0 from "./CsvTkc.vue?vue&type=style&index=0&id=2f17b279&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f17b279",
  null
  
)

export default component.exports